import { type Classroom } from "@/types/models/Classroom.interface";

const getClassroomStudentsList = (
  classrooms: Classroom[],
  classroomId: string,
) => {
  const foundClassroom = classrooms.find(
    (classroom) => classroom.unique_id === classroomId,
  );
  return foundClassroom?.students.sort((a, b) =>
    a.user.first_name.localeCompare(b.user.first_name),
  );
};

export default getClassroomStudentsList;
